"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = `
query getMonthOverview($year: Int!, $month: Month!) { 
  coachMonthOverview(year: $year, month: $month) { 
    traineesSummary {
      trainee {
        id      
        firstName 
        lastName
      }
      events {
        modelName
        start {
          iso8601
        }
        end {
          iso8601
        }
        days
        reasonStart
        reasonEnd
      }
    } 
  } 
}
`;
//# sourceMappingURL=getMonthOverview.js.map